import { FC } from "react";
import { IconProps, CodeIcon, CloudIcon } from "../icons/icons";

interface Service {
    icon: FC<IconProps>;
    title: string;
    description: string;
}

export const ServicesSection = () => {
  const services: Service[] = [
    {
      icon: CodeIcon,
      title: "UI/UX Design",
      description: "Modern, responsive web interfaces designed with usability and performance in mind. We create clean, scalable UIs using modern frameworks and design systems — tailored to your brand and your users’ needs.",
    },
    {
      icon: CodeIcon,
      title: "Backend Development & Architecture",
      description: "Scalable backend systems built with Java and Spring — including custom API development and architecture design. We engineer secure, reliable server-side logic that supports your app’s growth and complexity.",
    },
    {
      icon: CloudIcon,
      title: "DevOps & Cloud Infrastructure",
      description: "We design and manage CI/CD pipelines and DevOps workflows with GitHub Actions, Jenkins, Bamboo, and AWS. From cloud setup to automated deployments, we ensure high availability and efficient delivery across Firebase, Google Cloud, and more.",
    },
     {
      icon: CodeIcon,
      title: "Maintenance & Support",
      description: " Monthly support packages to keep your website secure, updated, and running smoothly.",
    },
     {
      icon: CodeIcon,
      title: "Web & App Development",
      description: "Custom websites and web applications built for performance, scalability, and great user experience — using modern technologies and tailored to your business goals.",
    },

   
  ];

  return (
    <section id="services" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-4">
          What We Do
        </h2>
        <p className="text-lg md:text-xl text-gray-500 text-center mb-10 md:mb-16">
          Focused services for maximum impact.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {services.map((service: Service, index: number) => (
            <div
              key={index}
              className="p-6 md:p-8 border-2 border-gray-100 rounded-2xl shadow-lg bg-white transition duration-300 hover:shadow-2xl hover:border-teal-300"
            >
              <service.icon className="w-8 h-8 md:w-10 md:h-10 text-orange-600 mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-500">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};